// billing.lang.en.js
const billingEN = {
	title: "Billing & Subscription",
	loading: "Loading...",
	errorLoading: "Unable to load billing details right now.",

	currentSubscription: "Current Subscription",
	noSubscription: "No subscription found.",
	startSubscription: "Start subscription",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Next billing: {date}",
	status: "Status",
	billingInterval: "Every {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Update payment method",
		cancelSubscription: "Cancel subscription",
		manageSubscription: "Manage subscription",
	},

	paymentMethod: {
		title: "Payment Method",
		noStored: "No payment method stored yet.",
		brand: "Brand",
		last4: "Last 4",
		expires: "Expires",
	},

	billingInfo: {
		title: "Billing Info",
		started: "Started",
		firstBilled: "First billed",
		nextBilling: "Next billing",
		interval: "Interval",
	},

	plans: {
		title: "Available Plans",
		options: "{count} options",
		choosePlan: "Choose plan",
	},

	seats: {
		activeSeats: "{count} seat(s) active",
		seatPricing: "{currency} {amount} per seat / month",
		total: "Total billed: {currency} {total}",
	},

	statusBadge: {
		active: "Active",
		canceled: "Canceled",
		paused: "Paused",
		trialing: "Trialing",
		pastDue: "Past due",
	},

	referral: {
		title: "Referral Program",
		loading: "Loading...",
		noCode: "You do not have a referral code yet.",
		generate: "Generate Referral Code",

		codeLabel: "Your Code:",
		copyCode: "Copy Code",
		copied: "Copied to clipboard",

		historyTitle: "Referral History",
		noReferrals: "No referrals yet.",
		defaultShopName: "New Shop",

		status: {
			pending: "Pending",
			active: "Active",
			converted: "Converted",
		},
	},

	misc: {
		month: "month",
	},
};

export default billingEN;
